/* Blog grid — honest AJAX "Load more". Added by Oleg @ IAKOE.
   Fetches the next page through the Section Rendering API
   (`<path>?section_id=<id>&<paginate.page_param>=N`) and appends only the new cards. Uses the
   current pathname, so it keeps working on tagged views (/blogs/blog/tagged/...).
   Page state is tracked on the button (data-next-page / data-total-pages). */
if (!customElements.get('ts-blog-grid')) {
  customElements.define(
    'ts-blog-grid',
    class TsBlogGrid extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelector('[data-items]');
        this.btn = this.querySelector('[data-load-more]');
        this.sectionId = this.dataset.sectionId;
        if (!this.items || !this.btn) return;
        this.btn.addEventListener('click', () => this.loadMore());
      }

      async loadMore() {
        if (this.loading) return;
        const next = parseInt(this.btn.dataset.nextPage, 10) || 2;
        const total = parseInt(this.btn.dataset.totalPages, 10) || 1;
        this.loading = true;
        this.btn.disabled = true;
        this.btn.classList.add('adding'); // kit button loading state: hides label, shows the spinner
        try {
          const url = new URL(location.pathname, location.origin);
          url.searchParams.set('section_id', this.sectionId);
          url.searchParams.set(this.dataset.pageParam || 'page', next);
          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const incoming = doc.querySelector('[data-items]');
          if (incoming) {
            const frag = document.createDocumentFragment();
            while (incoming.firstElementChild) frag.appendChild(incoming.firstElementChild);
            this.items.appendChild(frag);
          }
          if (next >= total) {
            (this.btn.closest('.ts-blog-grid__more') || this.btn).remove();
          } else {
            this.btn.dataset.nextPage = String(next + 1);
          }
        } catch (e) {
          /* keep the button so the user can retry */
        } finally {
          this.loading = false;
          this.btn.disabled = false;
          this.btn.classList.remove('adding');
        }
      }
    }
  );
}
